
<div class="main_content">
    <div class="page_main_sec p-0">
        <div class="selection_pg_main_sec">
            <div class="selection-bx-wrap">
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay=".1s">
                    <svg class="svg_bg">
                        <defs>
                            <filter id="f1" x="0" y="0">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="25" />
                            </filter>
                        </defs>
                        <rect width="100%" height="100%" stroke="rgba(34, 32, 34, .7)" stroke-width="3"
                            fill="rgba(34, 32, 34, .7)" filter="url(#f1)" />
                    </svg>

                    <div class="icon_float_sec proj_bg_img scale-transition scale-out">
                        <img src="/assets/img/project_main.png" alt="Project">
                    </div>
                    <div class="title-wrap bx-title">
                        <p class="title bold">Project</p>
                    </div>
                    <ul class="selection-list proj-li">
                        <li [ngClass]="{'selected' : selectedProjectId == proj.projectId}"
                            *ngFor="let proj of projectList" (click)="getSubgroups(proj.projectId)">
                            <div class="selected-check">
                                <img src="/assets/img/project.png" alt="Project">
                                <span>{{proj.projectName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay=".8s">
                    <svg class="svg_bg">
                        <defs>
                            <filter id="f1" x="0" y="0">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="25" />
                            </filter>
                        </defs>
                        <rect width="100%" height="100%" stroke="rgba(34, 32, 34, .7)" stroke-width="3"
                            fill="rgba(34, 32, 34, .7)" filter="url(#f1)" />
                    </svg>
                    <div class="icon_float_sec teritory_bg_img scale-transition scale-out">
                        <img src="/assets/img/map.svg" alt="Map">
                    </div>
                    <div class="title-wrap bx-title">
                        <p class="title bold">Territory</p>
                    </div>
                    <ul class="selection-grid">
                        <li [ngClass]="{'selected' : selectedSubgroupId == territory.territoryId}"
                            *ngFor="let territory of territoryList" (click)="getRoles(territory.territoryId)">
                            <div class="selected-check">
                                <img src="{{territory.logo}}" alt="England" class="img-fluid">
                                <p>{{territory.territoryName}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="bx wow zoomIn" data-wow-duration=".8s" data-wow-delay="1.6s">
                    <svg class="svg_bg">
                        <defs>
                            <filter id="f1" x="0" y="0">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="25" />
                            </filter>
                        </defs>
                        <rect width="100%" height="100%" stroke="rgba(34, 32, 34, .7)" stroke-width="3"
                            fill="rgba(34, 32, 34, .7)" filter="url(#f1)" />
                    </svg>
                    <div class="icon_float_sec role_bg_img scale-transition scale-out">
                        <img src="/assets/img/administrator.svg" alt="Admin">
                    </div>
                    <div class="title-wrap bx-title">
                        <p class="title bold">Role</p>
                    </div>
                    <ul class="selection-list role-li">
                        <li [ngClass]="{'selected' : selectedRoleId == role.roleId}"
                            *ngFor="let role of roleList" (click)="onSelectRole(role.roleId)">
                            <div class="selected-check">
                                <img src="/assets/img/user.png" alt="User">
                                <span>{{role.roleName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

